<template>
  <div>

    <div class="toggle-current-geolocation-display">
      <svg
        class="w-6 h-6 select-none text-green-800"
        role="button"
        aria-label="Toggle display of current geo location table"
        :class="`rotate(${rotateByHeading}deg)`"
        @click="toggleCurrentGeolocationDisplay"
      >
        <use v-if="!currentGeoLocDisplayStatus" xlink:href="#plus-circle"/>
        <use v-if="currentGeoLocDisplayStatus" xlink:href="#minus-circle"/>
       </svg>
    </div>

    <div id="currentGeoLocDisplay" class="toggle-geo-loc-display"
      :class="{
        'transform scale-x-100': currentGeoLocDisplayStatus === true,
        'transform scale-x-0': currentGeoLocDisplayStatus === false
      }">

      <!-- <div class="w-full mb-2">Current data</div> -->

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Lat</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.lat }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Lon</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.lon }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Accuracy</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.accuracy }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Altitude</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.altitude }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Altitude Accuracy</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.altitudeAccuracy }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Heading</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.heading }}</div>
      </div>

      <div class="flex flex-row mb-2">
        <div class="w-14 font-bold mr-2">Speed</div>
        <div class="flex-grow mx-2">{{ currentGeolocation.speed }}</div>
      </div>

      <!--
        <div class="flex flex-row mb-2">
          <div class="w-14 font-bold mr-2">Recording</div>
          <div class="flex-grow mx-2">{{ currentGeolocation.recording }}</div>
        </div>

        <div class="flex flex-row mb-2">
          <div class="w-14 font-bold mr-2">Distance</div>
          <div class="flex-grow mx-2">{{ currentGeolocation.distanceM }} m</div>
        </div>

        <div class="flex flex-row mb-2">
          <div class="w-14 font-bold mr-2"></div>
          <div class="flex-grow mx-2">{{ currentGeolocation.distanceKM }} km</div>
        </div>

        <div class="flex flex-row mb-2">
          <div class="w-14 font-bold mr-2">Steps</div>
          <div class="flex-grow mx-2">{{ currentGeolocation.steps }}</div>
        </div>

        <div class="flex flex-row mb-2">
          <div class="w-14 font-bold mr-2">Zoom Level</div>
          <div class="flex-grow mx-2">{{ zoomLevelCurrent }}</div>
        </div>
      -->

    </div>

  </div>
</template>

<script>
export default {
  name: 'GeoDataDisplay',
  props: {
    currentGeolocation: {
      type: [Object, Array],
      required: true
    },
    zoomLevelCurrent: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      currentGeoLocDisplayStatus: false
    }
  },
  computed: {
    rotateByHeading () {
      return this.currentGeolocation.heading
    }
  },
  methods: {
    toggleCurrentGeolocationDisplay () {
      this.currentGeoLocDisplayStatus = !this.currentGeoLocDisplayStatus
    }
  }

}
</script>

<style lang="postcss" scoped>

.toggle-current-geolocation-display {
  @apply absolute ;
  @apply select-none cursor-pointer z-10;
}

.toggle-current-geolocation-display {
  @apply left-2.5 top-53 bg-white rounded-full p-1;
  @apply transition bg-opacity-70;
}
.toggle-current-geolocation-display:hover {
  @apply transition bg-opacity-90;
}

.toggle-geo-loc-display {
  @apply absolute left-11 top-19 px-2 py-2;
  @apply flex flex-col;
  @apply rounded-md bg-white bg-opacity-80 text-sm leading-none overflow-hidden z-120;
  @apply transition origin-top-left select-none cursor-pointer;
}

</style>
